import React from 'react'

const Banner = () => {
  return (
   
        <div className='bann'>
            <div>
<div className='imagediv'><img className='imgs' src='https://images.squarespace-cdn.com/content/v1/62dc43e419bfa717fc15773f/ef74c10d-7db5-4882-8f4c-7df8030e4a52/headshot.jpeg?format=1500w' alt='d'/></div>
            </div>
            <div className='text'>
                <h1 className='gradu'>Graduate student at the University of Southern California pursuing a Master
                 of Science in Entrepreneurship and Innovation with career interests in tech, sports, and music.</h1>
            </div>
        </div>
   
  )
}

export default Banner